// EmailJS Configuration
// 
// SETUP INSTRUCTIONS:
// 1. Create a free account at https://www.emailjs.com/
// 2. Add an email service (Gmail, Outlook, etc.)
// 3. Create an email template with the following variables:
//    {{nome}}, {{azienda}}, {{ruolo}}, {{email}}, {{telefono}}, 
//    {{tipoRichiesta}}, {{dataEvento}}, {{citta}}, {{budgetRange}}, {{messaggio}}
// 4. Get your Public Key from Account > API Keys
// 5. Get your Service ID from Email Services
// 6. Get your Template ID from Email Templates
// 7. Replace the values below with your actual credentials

export const EMAILJS_CONFIG = {
  // Your EmailJS Public Key (found in Account > API Keys)
  PUBLIC_KEY: "L-4M1Cw0beWMbEDP6",
  
  // Your EmailJS Service ID (found in Email Services)
  SERVICE_ID: "service_9013neh",
  
  // Your EmailJS Template ID (found in Email Templates)
  TEMPLATE_ID: "template_uyu5wgm",
  
  // Recipient email (this is configured in EmailJS template)
  // Default: info@foodyburger49.it
};

// Example Email Template for EmailJS:
// 
// Subject: Nuova Richiesta da Foody Burger 49 Website
//
// Hai ricevuto una nuova richiesta di contatto:
//
// INFORMAZIONI CONTATTO:
// Nome: {{nome}}
// Azienda: {{azienda}}
// Ruolo: {{ruolo}}
// Email: {{email}}
// Telefono: {{telefono}}
//
// DETTAGLI PROGETTO:
// Tipo richiesta: {{tipoRichiesta}}
// Data evento: {{dataEvento}}
// Città: {{citta}}
// Budget: {{budgetRange}}
//
// MESSAGGIO:
// {{messaggio}}
